import { FC, useEffect } from "react";
import { StockNumericType } from "data/enums";
import { stockDetailPath } from "data/stock_types";
import { useLazyGetExperienceMultipleQuery, useGetExperienceMultipleQuery } from "application/features/experience/experienceApiSlice";
import { useLazyGetPropertyMultipleQuery, useGetPropertyMultipleQuery } from "application/features/property/propertyApiSlice";
import GallerySlider from "components/GallerySlider/GallerySlider";
import StartRating from "components/StartRating/StartRating";
import { useNavigate } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import moment from "moment";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { AddToCalendarButton } from 'add-to-calendar-button-react';
import { formatPrice } from 'shared/AppFunctions/formatPrice';


export interface HolidayPackageCardProps {
  className?: string;
  data?: any;
  size?: "default" | "small";
  customData?: any;
  href?: string;
  showRefund?: boolean;
  onRefundClick?: () => void;
  onReviewClick?: () => void;
  showReview?: boolean;
  navigationIsNotAlowed?: boolean;
  myReservations?: boolean;
  score?: number;
  bookingPrice?: number;
  check_in?: string;
  check_out?: string;
  showCanceled?: boolean;
  showEdit?: boolean;
  showAddToCalendar?: boolean;
}

const HolidayPackageCard: FC<HolidayPackageCardProps> = ({
  size = "default",
  className = "",
  data,
  href,
  showRefund,
  showReview,
  onRefundClick,
  onReviewClick,
  showCanceled,
  myReservations,
  bookingPrice,
  score,
  check_in,
  check_out,
  showEdit,
  showAddToCalendar,
}) => {
  const navigate = useNavigate();

  const {
    package_uuid,
    name,
    address,
    max_guests,
    duration_days,
    price,
    package_content,
    reviews,
    rating,
    cover_image,
    cover,
    gallery_images,
    description,
  } = data;

  // Support both cover_image and cover fields
  const displayCover = cover_image || cover;

  const fullLink = href ? href : stockDetailPath(StockNumericType.HOLIDAY_PACKAGE, package_uuid);

  const relatedExperienceUUIDs = package_content?.filter(
    (item: any) => item.type === "experience"
  ).map((item: any) => item.uuid);
  // const [getExperienceMultiple, experienceResults] = useLazyGetExperienceMultipleQuery();
  // const { data: experienceData, isLoading: isLoadingExperience, isError: isErrorExperience } = useGetExperienceMultipleQuery(relatedExperienceUUIDs || []);

  const relatedPropertyUUIDs = package_content?.filter(
    (item: any) => item.type === "property"
  ).map((item: any) => item.uuid);
  // const [getPropertyMultiple, propertyResults] = useLazyGetPropertyMultipleQuery();
  // const { data: propertyData, isLoading: isLoadingProperty, isError: isErrorProperty } = useGetPropertyMultipleQuery(relatedPropertyUUIDs || []);
  // console.log("propertyData", propertyData);
  // useEffect(() => {
  //   if (relatedExperienceUUIDs && relatedExperienceUUIDs.length > 0) {
  //     getExperienceMultiple(relatedExperienceUUIDs);
  //   }
  //   if (relatedPropertyUUIDs && relatedPropertyUUIDs.length > 0) {
  //     getPropertyMultiple(relatedPropertyUUIDs);
  //   }
  // }, [data]);

  const bookingPriceFormatted = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(bookingPrice || 0);
  // Use centralized price formatting with 30% commission + 22% VAT
  const priceFormatted = formatPrice(price || 0, true);

  const renderSliderGallery = () => {

    let allCovers = [];

    if (displayCover) {
      allCovers.push(displayCover);
    }

    if (gallery_images && gallery_images.length > 0) {
      allCovers = [...allCovers, ...gallery_images];
    }

        // if (propertyData) {
    //   const propertyCovers = propertyData?.map((item: any) => item.cover) || [];
    //   allCovers = [...propertyCovers];
    // }

    // if (experienceData) {
    //   const experienceCovers = experienceData?.map((item: any) => item.cover) || [];
    //   allCovers = [...allCovers, ...experienceCovers];
    // }

    return (
      <div className="relative w-full">
        <GallerySlider
          uniqueID={`holiday_package_${package_uuid}`}
          ratioClass="aspect-w-4 aspect-h-3 "
          galleryImgs={allCovers}
        />
        {/*saleOff && <SaleOffBadge className="absolute left-3 top-3" />*/}
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
        <div className="space-y-2">
          <span className="text-sm text-neutral-500 dark:text-neutral-400">
            {max_guests || data.min_guests || data.defined_guests || 1} guests • {duration_days || data.days_duration || 1} days
          </span>
          <div className="flex items-center space-x-2">
            {/*isAds && <Badge name="ADS" color="green" />*/}
            <h2
              className={` font-medium capitalize ${size === "default" ? "text-lg" : "text-base"
                }`}
            >
              <span className="line-clamp-1">{name}</span>
            </h2>
          </div>
          <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
            {size === "default" && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            )}
            <span className="">{address}</span>
          </div>
          {description && size === "default" && (
            <div className="text-sm text-neutral-6000 dark:text-neutral-400 mt-2 line-clamp-2">
              {description}
            </div>
          )}
        </div>
        <div className="w-14 border-b border-neutral-100 dark:border-neutral-800"></div>
        <div className="flex justify-between items-center">
          {
            !myReservations &&
            <span className="text-base font-semibold">
              da {priceFormatted}
              {` `}
              {size === "default" && (
                <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                  /per persona
                </span>
              )}
            </span>
          }
          {
            myReservations &&
            <div className="text-base font-semibold flex flex-col">
              <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                <b>Pagato</b> {bookingPriceFormatted}
              </span>
              <span className="text-sm text-neutral-500 dark:text-neutral-400">
                Dal {moment(check_in).format("DD MMM")} al {moment(check_out).format("DD MMM")}
              </span>
            </div>
          }
          {!!rating && (
            <StartRating reviewCount={reviews} point={rating} />
          )}
        </div>
        {
          showRefund && (
            <div className="flex items-center justify-between">
              <ButtonSecondary
                onClick={onRefundClick}
              >
                Annulla prenotazione
              </ButtonSecondary>
              {showAddToCalendar && (
                <div className="absolute z-[99] right-2">
                  <AddToCalendarButton
                    name={data?.name}
                    startDate={moment(check_in).format("YYYY-MM-DD")}
                    options={['Apple', 'Google', 'MicrosoftTeams']}
                    timeZone="Europe/Rome"
                    buttonStyle="round"
                    hideTextLabelButton
                    size="5"
                    listStyle="overlay"
                    language="it"
                    buttonsList
                  ></AddToCalendarButton>
                </div>
              )}
            </div>
          )
        }
        {
          showEdit && (
            <div className="flex items-center justify-between">
              <div onClick={(e) => e.stopPropagation()}>
                <ButtonPrimary
                  onClick={() => {
                    const packageId = package_uuid || data?.uuid || data?.id;

                    if (!packageId) {
                      alert("Errore: ID pacchetto non trovato");
                      return;
                    }

                    const editUrl = "/host/edit-holiday-package/" + packageId;
                    navigate(editUrl);
                  }}
                >
                  Modifica
                </ButtonPrimary>
              </div>
            </div>
          )
        }
        {
          showReview && (

            score ?
              <div className="flex items-center justify-between">
                <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                  La tua recensione:
                </span>
                <StartRating reviewCount={1} point={score} />
              </div>
              :
              <div className="flex items-center justify-between">
                <ButtonPrimary
                  onClick={onReviewClick}
                >
                  Scrivi una recensione
                </ButtonPrimary>
              </div>
          )
        }
        {
          showCanceled && (
            <div className="flex items-center justify-between">
              <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                Prenotazione annullata
              </span>
            </div>
          )
        }
      </div>
    );
  };

  return (
    <div
      className={`nc-HolidayPackageCard group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden will-change-transform hover:shadow-xl transition-shadow ${className}`}
      data-nc-id="HolidayPackageCard"
    >
      {
        renderSliderGallery()
      }
      <div onClick={() => {navigate(fullLink) }}>
        {
          renderContent()
        }
      </div>
    </div >
  );
};

export default HolidayPackageCard;
